import React from 'react'
import { Card, Skeleton, Space, theme, Alert, Flex } from 'antd'

const CategoryCardSkeleton = () => {
    const { token: themeToken } = theme.useToken()

    return (
        <Card
            style={{
                width: '100%',
                padding: '16px',
                height: '100%',
                backgroundColor: themeToken.colorBgContainer,
            }}
            styles={{
                body: {
                    padding: 0,
                    width: '100%',
                    height: '100%'
                }
            }}
        >
            <Space direction='vertical' style={{ width: '100%', height: '100%' }} size="middle">
                {/* Header: Points + Title */}
                <Flex gap={8} style={{ width: '100%' }}>
                    {/* Points badge skeleton */}
                    <Skeleton.Button
                        active
                        size="small"
                        style={{ width: '40px', height: '24px' }}
                    />
                    {/* Title skeleton */}
                    <Skeleton.Input
                        active
                        size="small"
                        block
                        style={{ width: '100%', height: '24px' }}
                    />
                </Flex>

                {/* Category name/short description */}
                <Skeleton
                    active
                    paragraph={{
                        rows: 3,
                        width: ['90%', '95%', '60%']
                      }}
                    title={false}
                />

                {/* Why it applies section in Alert-like container */}
                <Alert
                    style={{ 
                        backgroundColor: 'transparent',
                        border: `1px solid ${themeToken.colorBorder}`
                    }}
                    message={
                        <Skeleton
                            active
                            paragraph={{
                                rows: 2,
                                width: ['100%', '80%']
                            }}
                            title={false}
                        />
                    }
                />
            </Space>
        </Card>
    )
}

export default CategoryCardSkeleton 